'use client'

import React, { useId, useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { Alert, Button, InputControl, InputLabel, InputMessage, Spinner } from '@ui/kit'
import { Typograph } from '@ui/Typograf/Typograph'
import { useAuthRecoveryMutation } from '@widgets/auth/password-recovery/api/auth-recovery'
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form'
import * as yup from 'yup'

const schema = yup.object({
  email: yup.string().email('Не похоже на E-Mail').required('Необходимо заполнить'),
})

export const PasswordRecovery = () => {
  const [status, setStatus] = useState<boolean | null>(null)

  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    criteriaMode: 'all',
    resolver: yupResolver(schema),
  })

  const { mutate: resetPasswordAction, isPending, reset: resetQuery } = useAuthRecoveryMutation()

  const onSubmit: SubmitHandler<FieldValues> = async (data) =>
    resetPasswordAction(data.email ?? '', {
      onSuccess: (data) => {
        if (data?.error) {
          setError('root.serverError', {
            type: 'server',
            message: data?.errorText,
          })
          setStatus(false)
        } else {
          setStatus(true)
          resetQuery()
          reset()
        }
      },
      onError: () => {
        setError('root.serverError', {
          type: 'server',
          message: 'Серверная ошибка. Попробуйте еще раз немного позднее.',
        })
      },
    })

  const emailId = useId()

  return (
    <form className="mt-8" onSubmit={handleSubmit(onSubmit)}>
      <div>
        {errors?.root?.serverError?.type === 'server' ? (
          <Alert view="error">
            <p className="font-semibold">Неверный логин или пароль</p>
            <p className="text-sm">Если забыли, пароль можно восстановить.</p>
          </Alert>
        ) : (
          ''
        )}

        {isPending ? (
          <div className="relative h-12">
            <Spinner />
          </div>
        ) : status === true ? (
          <Alert view="success">
            <p className="font-semibold mb-2">Проверьте почтовый ящик</p>
            <p className="text-sm">
              <Typograph>Мы отправили письмо с инструкцией о восстановлении пароля на указанный адрес электронной почты.</Typograph>
            </p>
          </Alert>
        ) : (
          ''
        )}
        <InputLabel view={errors.email ? `error` : `default`} htmlFor={emailId}>
          E-Mail
        </InputLabel>
        <InputControl
          type="email"
          id={emailId}
          placeholder={`Адрес электронной почты`}
          //autoComplete="on"
          view={errors.email ? `error` : `default`}
          onFocus={() => setStatus(null)}
          {...register('email')}
        />
        <InputMessage view={errors.email ? `error` : `default`} message={errors?.email?.message?.toString()} />
      </div>

      <div className="mt-6 mb-6">
        <Button type="submit" viewSize={`m`} fullWidth={true} disabled={isPending}>
          Отправить инструкцию
        </Button>
      </div>
    </form>
  )
}
